<template>
  <div v-if="field.filename || field.field_options.description" class="form-outline" :style="imageCenter ? 'text-align:center' : ''">
    <form-legend :field="field" class="pt-1" />
    <v-img v-if="field.filename" :style="styles" :src="`${config.apiUrl}/medias/forms/${field.filename}`" :alt="field.filename" contain class="py-2" />
    <div v-if="field.field_options.description" v-html="field.field_options.description" class="py-2 caption"></div>
  </div>
</template>

<script>
import config from '@/common/config';
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  mounted() {
    console.debug(`URL-Media ${this.field.filename}`);
  },
  data() {
    return {
      config,
    };
  },
  computed: {
    // cockpit property "Bildhöhe nicht begrenzt"
    isImgHeightNotConstrained() {
      return this.field && this.field.field_options ? this.field.field_options.image_full_width : 'undefined';
    },
    fullWidth() {
      return this.field && this.field.field_options ? this.field.field_options.full_width : 'undefined';
    },
    imageCenter() {
      return this.field && this.field.field_options ? this.field.field_options.image_center : false;
    },

    styles() {
      let styles = {};
      if (this.fullWidth) {
        if (this.isImgHeightNotConstrained) {
          styles.backgroundSize = 'contain';
          styles.width = '100%';
        } else {
          styles.width = 'auto';
          styles.maxWidth = '100%';
        }
      } else {
        console.debug('No fullWidth => no size adjustments');
      }

      return styles;
    },
  },
};
</script>
